import { useMemo } from "react";
import { computeCfdGuideTipHorizontalLayout, getCfdGuideGapBelow } from "./cfdGuideViewport";

export function useCfdGuideAnchoredTipLayout(
  anchor: { top: number; left: number; width: number; height: number } | null,
  scale: number
): { tipLeft: number; lineCenterInTip: number; tipWidth: number; gapBelow: number } | null {
  return useMemo(() => {
    if (!anchor || typeof window === "undefined") return null;
    const h = computeCfdGuideTipHorizontalLayout(anchor, scale);
    return { ...h, gapBelow: getCfdGuideGapBelow(scale) };
  }, [anchor, scale]);
}
